@let evaluation = evaluationFeature.selectors.currentEvaluation.asSignal();
@let isEvaluating = evaluationFeature.selectors.isEvaluating.asSignal();
@let errorMessage =
  evaluationFeature.selectors.evaluationErrorMessage.asSignal();

@if (isEvaluating) {
  <div class="atn-quiver-deployment-modal-evaluation__loader"></div>
} @else if (errorMessage) {
  <p>TODO: error state -- ERROR: {{ errorMessage }}</p>
} @else if (!evaluation) {
  <p>TODO: no data state</p>
} @else if (evaluation.commands) {
  <atn-quiver-deployment-modal-evaluation-step-complete
    [evaluation]="evaluation"
  />
} @else if (evaluation.requires) {
  <atn-quiver-deployment-modal-evaluation-step-incomplete
    [evaluation]="evaluation"
  />
}
